import React from 'react';
import { useDispatch } from 'react-redux';
import { updateQueryString } from 'services/router/actions';
import { SUPPORT_MODAL } from 'scenes/Home/components/SupportModal';
import SidebarNavigationItemButton from '../SidebarNavigationItemButton';

function SupportSidebarNavigationItem(): JSX.Element {
    const dispatch = useDispatch();

    const handleOnClick = (): void => {
        dispatch(updateQueryString({ [SUPPORT_MODAL]: true }));
    };

    return (
        <SidebarNavigationItemButton
            title="Support"
            iconName="FiThumbsUp"
            onClick={handleOnClick}
        />
    );
}

export default SupportSidebarNavigationItem;
